import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import App from 'modules/App';
import Account from 'modules/Account';
import SettingsIcon from 'svg/settings.svg';
import { NOTIFICATIONS_SETTINGS_MODAL } from '../../constants';
const SettingsButton = ()=>{
    const notificationsSettings = useSelector(Account.selectors.activeNotificationsSettings);
    const openModal = useAction(App.actions.openModal);
    return (notificationsSettings === null || notificationsSettings === void 0 ? void 0 : notificationsSettings.length) > 0 && /*#__PURE__*/ _jsx(Button, {
        id: "notifications-settings-btn",
        styleModifier: "transparent",
        onClick: ()=>openModal(NOTIFICATIONS_SETTINGS_MODAL),
        children: /*#__PURE__*/ _jsx(SettingsIcon, {})
    });
};
export default SettingsButton;
